export default "__VITE_ASSET__8621fc96__"